export default __webpack_public_path__ + "static/media/VIDEO_ICONAvideo.0e37b82e.svg";